// extracted by mini-css-extract-plugin
export default {"item":"style_item__WKxM0","img":"style_img__SYYS0","body":"style_body__2BE13","text":"style_text__8bMfd","status":"style_status__hAmeC"};